import React, { useState, useEffect } from "react";
import Pagination from "../../../utils/commonPagination";
import TransactionsList from "./TransactionList";
import { getTransactionList } from "../../../API/Transaction";
import { toast } from "react-toastify";
import NoData from "../../../components/NoData";
import TransactionDetail from "./TransactionDetail";
const Transactions = () => {
  const [transactionList, setTransactionList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewModal, setViewModal] = useState({
    open:false,
    detail:{}
  });
  const itemsPerPage = 10;
  const fetchAllTransaction = async (page) => {
    try {
      const response = await getTransactionList(page, itemsPerPage);
      if (response?.status) {
        setTransactionList(response?.data);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during fetch:", error);
    }
  };

  useEffect(() => {
    fetchAllTransaction(currentPage);
  }, [currentPage]);
const onTransactionDetail=(item)=>{
  setViewModal({open:true,detail:item})
}

  return (
    <div className="user_container">
      <div className="event_header management_header">
        <div className="title">Transactions</div>
      </div>
      {transactionList && transactionList?.paymentHistory?.length > 0 ? (
        <div className="users_list">
          <TransactionsList
            onTransactionDetail={onTransactionDetail}
            transactionList={transactionList?.paymentHistory}
          />
          <Pagination
            currentPage={currentPage}
            totalNoPages={transactionList?.totalNoPages}
            onNextPage={() => setCurrentPage(currentPage + 1)}
            onPreviousPage={() => setCurrentPage(currentPage - 1)}
          />
        </div>
      ) : (
        <NoData title="There is no transactions yet" />
      )}
      {
        viewModal?.open && <TransactionDetail onModalClose={setViewModal} transactionDetail={viewModal?.detail} />
      }
    </div>
  );
};
export default Transactions;
